<template>
  <div class="any" >
    <el-divider content-position="left">社保缴纳基数列表</el-divider>
    <el-row style="margin-bottom: .4rem">
      <el-col>
        <el-button type="primary" size="small"
          @click="anyDrawer=true">新增</el-button>
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </el-col>
    </el-row>
    <el-table
      :data="anyData"
      border
      style="width: 100%;margin-top:0.2rem;"
      size="mini"
      :header-cell-style="{background:'#ecf4ff',color:'#333',fontWeight:'900',fontSize:'0.28rem'}">
      <el-table-column
        prop="id"
        label="ID"
        width="150">
      </el-table-column>
      <el-table-column
        prop="social"
        label="社保缴纳基数"
        width="150">
      </el-table-column>
      <!-- <el-table-column
        prop="accumulation"
        label="公积金缴纳基数"
        width="150">
      </el-table-column> -->
      <el-table-column
        fixed="right"
        label="操作"
        width="100">
        <template slot-scope="scope">
          <el-button
            @click="handleClick(scope.row,scope.$index)"
            type="primary"
            size="mini"
            icon="el-icon-edit"
            circle
          >
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div>
    <el-drawer
      title="录入"
      :visible.sync="anyDrawer"
      :direction="direction"
      size="40%">
      <div style="padding:0.4rem 0.2rem">
        <el-form :model="anyForm" ref="anyForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="社保缴纳基数" prop="social">
            <el-input v-model="anyForm.social" size="mini"></el-input>
          </el-form-item>
          <!-- <el-form-item label="公积金缴纳基数" prop="accumulation">
          <el-input v-model="anyForm.accumulation" size="mini"></el-input>
          </el-form-item> -->
          <div style="text-align:right;margin-top:0.2rem">
            <el-button type="primary" size="mini" @click="submitForm('anyForm')">添加</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>
        <el-drawer
          title="修改"
          :visible.sync="anyEditDrawer"
          :direction="direction"
          size="40%">
        <div style="padding:0.4rem 0.2rem">
        <el-form :model="anyEditForm" ref="anyEditForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="社保缴纳基数" prop="social">
            <el-input v-model="anyEditForm.social" size="mini"></el-input>
          </el-form-item>
          <!-- <el-form-item label="公积金缴纳基数" prop="accumulation">
          <el-input v-model="anyEditForm.accumulation" size="mini"></el-input>
          </el-form-item> -->
          <div style="text-align:right;margin-top:0.2rem">
            <el-button type="primary" size="mini" @click="editSubmitForm('anyEditForm')">保存</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'Any',
  data () {
    return {

      anyData: [],
      anyDrawer: false,
      anyEditDrawer: false,
      anyForm: {
        social: '',
        accumulation: ''
      },
      anyEditForm: {
        social: '',
        accumulation: ''
      },
      direction: 'rtl',
      nPage: 1,
      categoryPerPage: 10,
      total: null,
      rowId: '',
      nRow: ''
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.loadAnytable()
  },
  methods: {
    loadAnytable () {
      this.$axios.get('api/social/getinfo', {
        params: {
          page: this.nPage,
          perpage: this.categoryPerPage
        }
      }).then((res) => {
        const { data } = res
        if (data.code === 1) {
          this.anyData = data.data.data
          this.total = data.data.total
        } else {
          this.$message.error(data.msg)
        }
      }).catch()
    },
    handleClick (row, index) {
      this.anyEditDrawer = true
      this.nRow = index
      this.rowId = row.id
      this.$axios.get('api/social/showinfo?id=' + row.id
      ).then((res) => {
        const { data } = res
        if (data.code === 1) {
          this.anyEditForm.social = data.data.social
        } else {
          this.$message.error(data.msg)
        }
      }).catch()
    },
    submitForm (formName) {
      var social = this.anyForm.social
      if (!social) {
        this.$message.error('请输入内容！')
        return false
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post('api/social/addinfo', {
            social
          }).then((res) => {
            const { data } = res
            if (data.code === 1) {
              this.$message.success(data.msg)
              this.loadAnytable()
            } else {
              this.$message.error(data.msg)
            }
          }).catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSubmitForm (formName) {
      var social = this.anyEditForm.social
      if (!social) {
        this.$message.error('请输入内容！')
        return false
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.put('api/social/editinfo?id=' + this.rowId, {
            social
          }).then((res) => {
            const { data } = res
            if (data.code === 1) {
              this.$message.success(data.msg)
              this.anyData[this.nRow].social = social
            } else {
              this.$message.error(data.msg)
            }
          }).catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleCurrentChange (val) {
      this.nPage = val
      this.loadAnytable()
    },
    handleSizeChange (val) {
      this.categoryPerPage = val
      this.loadAnytable()
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
  .any{
    /* margin-left: 3.6rem; */
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/any/Any.vue